<div class="page_container">
  <ui-page-header [title]="'settings.orders' | translate" [lucideIcon]="'ShoppingBag'">
    <ui-button
      type="secondary"
      [label]="'settings.restore_defaults' | translate | uppercase"
      icon="refresh-cc"
      iconPosition="start"
      (click)="restoreDefaults()">
    </ui-button>
    <ui-button
      type="primary"
      [label]="'settings.save' | translate | uppercase"
      icon="check_icon"
      iconPosition="start"
      (click)="save()">
    </ui-button>
  </ui-page-header>

  <section class="pricing_section">
    <h2 class="section_title">{{ 'settings.orders_settings.default_price_source' | translate }}</h2>
    <p class="section_hint">
      <img src="assets/icones/info.svg" alt="" />
      <span>{{ 'settings.orders_settings.default_price_source_hint' | translate }}</span>
    </p>

    <div class="price_cards">
      <div
        *ngFor="let option of priceSourceOptions"
        class="price_card"
        [class.selected]="priceSource === option.value"
        (click)="selectPriceSource(option.value)"
        role="radio"
        [attr.aria-checked]="priceSource === option.value"
        tabindex="0"
        (keydown.enter)="selectPriceSource(option.value)"
        (keydown.space)="selectPriceSource(option.value)">
        <div class="price_card_header">
          <span class="radio" [class.checked]="priceSource === option.value"></span>
          <span class="price_card_title">
            {{ option.title | translate }}
            <span class="default_tag" *ngIf="option.isDefault">{{ 'settings.orders_settings.price_source.default_tag' | translate }}</span>
          </span>
        </div>
        <p class="price_card_description">{{ option.description | translate }}</p>
      </div>
    </div>

    <!-- Only relevant when "No price by default" is the selected source, so it is
         its own full-width block below the cards rather than a disabled control
         tucked inside one of them. -->
    <div class="hide_columns" *ngIf="priceSource === 'none'">
      <div class="hide_columns_info">
        <span class="hide_columns_title">{{ 'settings.orders_settings.hide_pricing_columns' | translate }}</span>
        <p class="hide_columns_description">{{ 'settings.orders_settings.hide_pricing_columns_description' | translate }}</p>
      </div>
      <mat-slide-toggle
        [checked]="hidePricingColumns"
        (change)="onHidePricingColumnsChange($event.checked)"
        color="primary">
      </mat-slide-toggle>
    </div>
  </section>

  <!-- ── Order splitting rules ───────────────────────────────────────────── -->
  <section class="settings_section">
    <app-splitting-rules-list
      [rules]="splittingRules"
      [loading]="splittingRulesLoading"
      (addRule)="openRuleDrawer()"
      (edit)="openRuleDrawer($event)"
      (delete)="onDeleteRule($event)"
      (toggle)="onToggleRule($event)">
    </app-splitting-rules-list>
  </section>
</div>

<!-- Drawer (outside page_container to avoid overflow clipping) -->
<app-splitting-rule-drawer
  [open]="drawerOpen"
  [rule]="selectedRule"
  [existingRules]="splittingRules"
  (save)="onSaveRule($event)"
  (closeDrawer)="drawerOpen = false">
</app-splitting-rule-drawer>
